import * as React from 'react';
import Timeline from '@mui/lab/Timeline';
import TimelineItem from '@mui/lab/TimelineItem';
import TimelineSeparator from '@mui/lab/TimelineSeparator';
import TimelineConnector from '@mui/lab/TimelineConnector';
import TimelineContent from '@mui/lab/TimelineContent';
import TimelineDot from '@mui/lab/TimelineDot';
import Grid from '@mui/material/Grid';
import Button from '@mui/material/Button';
import { obterCorPorStatus } from '../utils';
import { useTheme } from '@mui/material/styles';
import CheckIcon from '@mui/icons-material/Check';

export default function NotaItem({ nota, statuses }) {
  const [analiseGestor, setAnaliseGestor] = React.useState();
  const [analiseFinanceiro, setAnaliseFinanceiro] = React.useState();
  const [pendencia, setPendencia] = React.useState();
  const [aguardandoPagamento, setAguardandoPagamento] = React.useState();
  const [pago, setPago] = React.useState();
  const theme = useTheme();

  React.useEffect(() => {
    if (nota && nota.log_situacao) {
      setAnaliseGestor(
        nota.log_situacao.find(
          (result) => result.situacao === 'EM ANALISE GESTOR',
        ),
      );
      setAnaliseFinanceiro(
        nota.log_situacao.find(
          (result) => result.situacao === 'EM ANALISE FINANCEIRO',
        ),
      );
      setPendencia(
        nota.log_situacao.find((result) => result.situacao === 'PENDENCIA'),
      );
      setAguardandoPagamento(
        nota.log_situacao.find(
          (result) => result.situacao === 'AGUARDANDO PAGAMENTO',
        ),
      );
      setPago(nota.log_situacao.find((result) => result.situacao === 'PAGO'));
    }
  }, [nota]);

  return (
    <>
      <Grid container spacing={0}>
        <Grid item xs={6} style={{ background: '#FAFCFF' }} paddingX="0.5rem">
          <p style={{ color: theme.palette.primary.main }}>
            Ordens de serviços vinculadas a nota fiscal
          </p>
          <table style={{ width: '100%' }}>
            <thead style={{ textAlign: 'left', color: '#0e72b8' }}>
              <tr>
                <th style={{ width: '20%', textAlign: 'left' }}>Nº O.S.</th>
                <th style={{ width: '50%', textAlign: 'left' }}>Descrição</th>
                <th style={{ width: '30%', textAlign: 'left' }}>Valor</th>
              </tr>
            </thead>
            <tbody>
              {nota.ordem_servico &&
                nota.ordem_servico.map((os, index) => {
                  return (
                    <tr key={index}>
                      <td
                        style={{
                          color: '#0e72b8',
                          width: '20%',
                          fontSize: '0.8rem',
                          paddingLeft: '1rem',
                        }}
                      >
                        {os.numero_ordem_servico}
                      </td>
                      <td
                        style={{
                          width: '50%',
                          fontSize: '0.8rem',
                          paddingLeft: '1rem',
                        }}
                      >
                        {os.descricao}
                      </td>
                      <td
                        style={{
                          width: '30%',
                          fontSize: '0.8rem',
                          paddingLeft: '1rem',
                        }}
                      >
                        R$ {os.outro_valor}
                      </td>
                    </tr>
                  );
                })}
            </tbody>
          </table>
        </Grid>
        <Grid item xs={6}>
          <h3 style={{ color: theme.palette.primary.main }}>
            Situação da nota fiscal
          </h3>
          <Timeline position="right">
            {statuses &&
              statuses.map((item, index) => {
                return (
                  <TimelineItem key={`item-key-${index}`}>
                    <TimelineSeparator>
                      <TimelineDot
                        style={{ width: 10, height: 10 }}
                        color={index == 0 ? 'grey' : 'primary'}
                      >
                        <CheckIcon
                          fontSize="10"
                          style={{ marginLeft: -2, marginTop: -2 }}
                        />
                      </TimelineDot>
                      <TimelineConnector
                        sx={{
                          bgcolor: index == 0 ? 'grey' : 'primary.main',
                        }}
                      />
                    </TimelineSeparator>
                    <TimelineContent style={{ padding: '0px 16px 16px 16px' }}>
                      <div style={{ display: 'flex', alignItems: 'center' }}>
                        <Button
                          style={{
                            borderRadius: 20,
                            width: '60%',
                            height: 25,
                            fontSize: 10,
                          }}
                          variant="contained"
                          color={obterCorPorStatus(item.desc_movto)}
                        >
                          {item.desc_movto}
                        </Button>
                        <span
                          style={{
                            color: '#919191',
                            fontSize: 10,
                            marginLeft: 10,
                          }}
                        >
                          {item.data_movto} às {item.hora_movto}
                        </span>
                      </div>
                      <div>
                        <span
                          style={{
                            color: '#919191',
                            fontWeight: 'bold',
                            fontSize: '12px',
                          }}
                        >
                          Observações:
                        </span>
                        <span
                          style={{
                            color: '#919191',
                            marginLeft: 10,
                            fontSize: '12px',
                          }}
                        >
                          {item.obs_movto}
                        </span>
                      </div>
                    </TimelineContent>
                  </TimelineItem>
                );
              })}
          </Timeline>
        </Grid>
      </Grid>
    </>
  );
}
